module.exports = __webpack_public_path__ + "media/images/ban-regular-25f9e472.svg";